<template>
  <div class="form-control">
    <label class="block" :class="[themes_labes[theme]]" :for="name" v-if="label">
      <span v-html="label"></span>
      <span v-if="required" class="obligatoire">*</span>
    </label>

    <div>
      <table class="table table-act table-hover border-separate p-4">
        <thead>
          <tr class="text-sm text-grey font-normal w-full text-center">
            <th scope="col" class="auto" v-for="(h,index) in headers" :key="index">{{h.label}}</th>
            <th scope="col" class="auto text-center">{{ $t("team.actions") }}</th>
          </tr>
        </thead>
        <tbody class="w-full p-1">
          <tr
            class="w-full bg-white text-2sm text-grey-darker"
            v-for="(block, index) in blocks"
            :key="index"
          >
            <td
              class=" border-t border-b border-l p-4"
              :class="{'w-1/5':headers[bindex].type=='date','w-1/4': ['fundsList','marketType','list','countries','durationList','gouvernorate'].includes(headers[bindex].type), 'w-1/2': ['yearmonth', 'plan'].includes(headers[bindex].type) }"
              v-for="(b,bindex) in rows"
              :key="bindex"
            > 
              <dynamic-input 
                v-if="headers[bindex].type=='tableList'"
                v-model="block[b]"
                ref="dynamicInput"
                theme="form"
                type="tableList"
                :disabled="disabled"
                :name="b+'_'+index+bindex"
                :id="b+'_'+index+bindex"
              ></dynamic-input>

              <sp-input
                v-if="headers[bindex].type === 'string'"
                theme="form"
                v-model="block[b]"
                :name="b+'_'+index+bindex"
                :value="bindex"
                :disabled="disabled"
              ></sp-input>
              <sp-input
                v-if="headers[bindex].type=='number'"
                theme="form"
                v-model="block[b]"
                :name="b+'_'+index+bindex"
                :value="bindex"
                type="number"
                step="any"
                :disabled="disabled"
              ></sp-input>

              <sp-select
                theme="form"
                v-else-if="headers[bindex].type=='date'"
                v-model="block[b]"
                :selected="block[b]"
                :options="years"
                :name="b+'_'+index+bindex"
                :id="b+'_'+index+bindex"
                placeholder="Sélectionnez une option"
                :disabled="disabled"
              ></sp-select>
              <sp-select
                theme="form"
                v-else-if="headers[bindex].type=='list'"
                v-model="block[b]"
                :selected="block[b]"
                :options="list"
                :name="b+'_'+index+bindex"
                :id="b+'_'+index+bindex"
                placeholder="Sélectionnez une option"
                :disabled="disabled"
              ></sp-select>
              <sp-select
                theme="form"
                v-else-if="headers[bindex].type=='fundsList'"
                v-model="block[b]"
                :selected="block[b]"
                :options="fundsList"
                :name="b+'_'+index+bindex"
                :id="b+'_'+index+bindex"
                placeholder="Sélectionnez une option"
                :disabled="disabled"
              ></sp-select>
              <sp-select
                theme="form"
                v-else-if="headers[bindex].type=='countries'"
                v-model="block[b]"
                :selected="block[b]"
                :options="countries"
                :name="b+'_'+index+bindex"
                :id="b+'_'+index+bindex"
                placeholder="Sélectionnez une option"
                :disabled="disabled"
              ></sp-select>
              <sp-select
                theme="form"
                v-else-if="headers[bindex].type=='marketType'"
                v-model="block[b]"
                :selected="block[b]"
                :options="marketType"
                :name="b+'_'+index+bindex"
                :id="b+'_'+index+bindex"
                placeholder="Sélectionnez une option"
                :disabled="disabled"
              ></sp-select>
              <sp-select
                theme="form"
                v-else-if="headers[bindex].type=='durationList'"
                v-model="block[b]"
                :selected="block[b]"
                :options="durationList"
                :name="b+'_'+index+bindex"
                :id="b+'_'+index+bindex"
                placeholder="Sélectionnez une option"
                :disabled="disabled"
              ></sp-select>
              <sp-select
                theme="form"
                v-else-if="headers[bindex].type=='gouvernorate'"
                v-model="block[b]"
                :selected="block[b]"
                :options="gouvernorate"
                :name="b+'_'+index+bindex"
                :id="b+'_'+index+bindex"
                placeholder="Sélectionnez une option"
                :disabled="disabled"
              ></sp-select>
              <sp-select
                theme="form"
                v-else-if="headers[bindex].type=='yearmonth'"
                v-model="block[b]"
                :selected="block[b]"
                :options="yearMonth"
                :name="b+'_'+index+bindex"
                :id="b+'_'+index+bindex"
                placeholder="Sélectionnez une option"
                :disabled="disabled"
              ></sp-select>
              <sp-select
                theme="form"
                v-else-if="headers[bindex].type=='plan'"
                v-model="block[b]"
                :selected="block[b]"
                :options="plans"
                :name="b+'_'+index+bindex"
                :id="b+'_'+index+bindex"
                placeholder="Sélectionnez une option"
                :disabled="disabled"
              ></sp-select>
              <flat-picker
                v-if="headers[bindex].type=='startDate'"
                v-model="block[b]"
                ref="flatPickr"
                theme="form"
                :disabled="disabled"
                :name="b+'_'+index+bindex"
                :id="b+'_'+index+bindex"
                type="startDate"
                :config="{ dateFormat: 'd-m-Y' }"
                placeholder="Date de début"
                class="border border-grey rounded w-full mb-5 p-3 text-grey-darker leading focus:outline-none focus:bg-white border border-blue-light2 focus:border-blue-light focus:shadow-sm rounded text-grey-darker leading-tight"
              ></flat-picker>
              <flat-picker
                v-if="headers[bindex].type=='endDate'"
                v-model="block[b]"
                ref="flatPickr"
                theme="form"
                :disabled="disabled"
                :name="b+'_'+index+bindex"
                :id="b+'_'+index+bindex"
                type="endDate"
                placeholder="Date de fin"
                :config="{ dateFormat: 'd-m-Y' }"
                class="border border-grey rounded w-full mb-5 p-3 text-grey-darker leading focus:outline-none focus:bg-white border border-blue-light2 focus:border-blue-light focus:shadow-sm rounded text-grey-darker leading-tight"
              ></flat-picker>
            </td>
            <td class="border-t border-b border-l border-r p-4" style="width:50px">
              <div class="flex justify-center">
                <div class="mx-3">
                  <!-- <button
                    v-if="index==0"
                    type="button"
                    class="text-white rounded focus:outline-none focus:shadow-outline transition-all border rounded text-white border-green-darker bg-green-darker hover:text-green-darker hover:bg-white text-base p-2 py-2 px-4"
                    @click="addRow"
                    :disabled="disabled"
                  >
                    <i class="fas fa-plus"></i>
                  </button> -->
                  <sp-button theme="red" space="small" class @click="deleteRow(index)" :disabled="disabled">
                    <i class="fas fa-trash-alt"></i>
                  </sp-button>
                </div>
              </div>
            </td> 
          </tr>
        </tbody>
      </table>
      <button
          type="button"
          class="add-act-btn text-white rounded focus:outline-none focus:shadow-outline transition-all border rounded text-white border-green-darker bg-green-darker hover:text-green-darker hover:bg-white text-base p-2 py-2 mx-4"
          @click="addRow"
          :disabled="disabled"
          >
          <i class="fas fa-plus"></i>
       </button>
    </div>
  </div>
</template>
<style>
table.border-separate {
  border-spacing: 0 10px;
}
table.border-separate tbody tr {
  box-shadow: 0 2px 4px 0 rgba(29, 57, 100, 0.16);
  border-radius: 4px;
}
table.border-separate tbody tr:hover {
  box-shadow: 0 4px 8px 0 rgba(22, 66, 132, 0.19);
}

.table.border-separate tbody td {
  vertical-align: middle;
  border-color: rgba(29, 57, 100, 0.13);
}
.table.border-separate tbody tr:hover td {
  border-color: rgba(29, 57, 100, 0.23);
}

.table.border-separate thead th,
.table.border-separate thead td {
  border: none;
}

.add-act-btn {
  float: right;
  width: 40px;
  height: 44px;
  top: -65px;
}

.table-act {
  padding-bottom: inherit;
}

.lead {
  height: 20px;
  width: 58px;
  opacity: 0.5;
  color: #1d3964;
  font-family: Roboto;
  font-size: 14px;
  line-height: 20px;
}
</style>
<script>
import ButtonVue from "@/components/spKit/Button.vue";
import Input from "@/components/spKit/Input.vue";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import SelectVue from "./Select.vue";
import DynamicInput from "@/components/spKit/DynamicInput.vue";


export default {
  name: "sp-table-list",
  components: {
    "sp-input": Input,
    "sp-button": ButtonVue,
    "flat-picker": flatPickr,
    "sp-select": SelectVue,
    "dynamic-input": DynamicInput
  },
  props: {
    name: String,
    id: String,
    label: String,
    disabled: {
      type: Boolean,
      default: false
    },
    modelValue: {
      default: undefined
    },
    theme: {
      required: false,
      type: String,
      default: ""
    },
    required: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      required: true,
      default: "1"
    },
    selected: {
      type: String | Array,
      default: null
    },
    tag: {
        type: String,
        default: null
    }
  },
  data() {
    return {
      headers: null,
      blocks: [],
      empty_row: null,
      rows: null,
      years: null,
      list: null,
      tableList: null,
      countries: [],
      marketType: [],
      durationList: [],
      gouvernorate: [],
      fundsList: [],
      plans: [],
      yearMonth: [],
      foundersData: [],
      
      dynamicComponentValue: null,
      months: ['Janvier', 'Fevrier', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Aout', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
      themes: {
        default: "",
        form:
          "border border-blue-light2 focus:border-blue-light focus:shadow-sm rounded text-grey-darker leading-tight",
        team:
          "border border-blue-light2 focus:border-blue-light focus:shadow-sm rounded text-grey-darker leading-tight",
        "team-i":
          "border border-blue-light2 focus:border-blue-light focus:shadow-sm rounded text-grey-darker leading-tight pl-14"
      },
      themes_labes: {
        default: "mb-4",
        form: "text-blue text-2sm mb-4",
        team: "text-blue text-2sm font-bold mb-3",
        "team-i": "text-blue text-2sm font-bold mb-3"
      },
      education: {
        from_year: null,
        to_year: null,
      },
    };
  },
  beforeMount: function() {
    
    var duration = []
    for(var i = 1; i <= 12; i++){
      duration.push({value: i + 'mois', name: i + ' mois'})
    }
      this.durationList = duration
    var list = require("./selectCountry/countries.js");
    for (var i = 0; i < list.length; ++i) {
      var code = list[i].code;
      var name = list[i].name;
      if (this.$i18n && this.$i18n.country && this.$i18n.country[code]) {
        name = this.$i18n.country[code];
      }
      this.countries.push({
        value: code,
        name: name
      });
    }
    
    this.list = [
      { name: "Actions", value: "1" },
      {
        name: "Actions à dividende prioritaire",
        value: "2"
      },
      { name: "Titre participatif", value: "3" },
      { name: "OCA", value: "4" },
      { name: "CCA", value: "5" },
      { name: "Prêt", value: "6" },
      { name: "Prêt participatif", value: "7" },        
      { name: "Don", value: "8" },
      { name: "Autre", value: "9" }
      
    ];
  },
  mounted() {
    if (this.type == "1") {
      this.headers = [
        { label: "Année", type: "date" },
        { label: "Montant (DT)", type: "number" }
      ];
      this.empty_row = { year: null, amount: null };
      this.years = this.generateYears(5);
    } else if (this.type == "2") {
      this.headers = [
        { label: "Année", type: "date" },
        { label: "Nombre de salariés", type: "number" }
      ];
      this.empty_row = { year: null, number: null };
      this.years = this.generateYears(3);
    } else if (this.type == "3") {
      this.headers = [
        { label: "Année", type: "date" },
        { label: "Type de ressource", type: "list" },
        { label: "Nom/raison sociale", type: "string" },
        { label: "Montant (DT)", type: "number" }
      ];
      this.empty_row = {
        year: null,
        type: null,
        name: null,
        amount: null
      };
      if(this.tag == "custom_funding"){
          this.years = this.generateYearDeclaration(1);
      }else{
          this.years = this.generateYears(9);
      }
      this.list = [
        { name: "Actions", value: "1" },
        {
          name: "Actions à dividende prioritaire",
          value: "2"
        },
        { name: "Titre participatif", value: "3" },
        { name: "OCA", value: "4" },
        { name: "CCA", value: "5" },
        { name: "Prêt", value: "6" },
        { name: "Prêt participatif", value: "7" },        
        { name: "Don", value: "8" },
        { name: "Autre", value: "9" }
        
      ];
    } else if (this.type == "4") {
      this.headers = [
        { label: "Nom de l'actionnaire", type: "string" },
        { label: "Type de l'actionnaire", type: "list" },
        { label: "N° CIN ou id société", type: "string" },
        { label: "Pourcentage", type: "string" }
      ];
      this.empty_row = {
        name: null,
        type: null,
        cin: null,
        value: null
      };
      this.list = [
        { name: "Personne physique", value: "1" },
        { name: "Organisme d'investissement réglementé",value: "2" },
        { name: "Organisme d’investissement réglementé dépendant d’une société ou un groupe de sociétés", value: "3" }, 
        { name: "Société d’investissement individuelle", value: "4" },
        { name: "Startup étrangére", value: "5" },
        { name: "Société ou groupe de societés", value: "6" },
        { name: "Autre", value: "7" } 
      ];
    } else if (this.type == "17") {
      this.headers = [
        { label: "Nom et prénom", type: "string" },
        { label: "Responsabilité dans le projet", type: "string" },
        { label: "Profil/Qualification", type: "string" }
      ];
      this.empty_row = {
        name: null,
        responsable: null,
        profil: null,
      };
    }else if (this.type == "5") {
      this.headers = [
        { label: "Cible", type: "string" },
        { label: "Pays", type: "countries" },
        { label: "Année", type: "date" },
        { label: "Type de Marché", type: "marketType" }
      ];
      this.empty_row = {
        target: null,
        country: null,
        year: null,
        marketType: null
      };
      this.years = this.generateYears(9);
    }else if (this.type == "6") {
      this.headers = [
        { label: "Nom de l'organisme", type: "string" },
        { label: "Durée", type: "durationList" },
        { label: "Année", type: "date" },
        { label: "Localisation", type: "gouvernorate" }
      ];

      this.empty_row = {
        name: null,
        duration: null,
        year: null,
        location: null
      };
      this.years = this.generateYears(9);
    }else if (this.type == "7") {
      this.headers = [
        { label: "Invention", type: "string" },
        { label: "Année", type: "date" },
        { label: "Pays", type: "countries" }
      ];

      this.empty_row = {
        name: null,
        year: null,
        location: null
      };
      this.years = this.generateYears(9);
    }else if (this.type == "8") {
      this.headers = [
        { label: "Nom de l'organisme", type: "string" },
        { label: "Année", type: "date" },
        { label: "Montant (DT)", type: "number" },
        { label: "Type", type: "list" },
        { label: "Nature des fonds", type: "fundsList" }
      ];

      this.list = [
        { name: "Actions + Actions à dividende prioritaire", value: "1" },
        { name: "Titre participatif", value: "2" },
        { name: "OCA", value: "3" },
        { name: "CCA", value: "4" },
        { name: "Prêt", value: "5" },
        { name: "Prêt participatif", value: "6" },        
        { name: "Don", value: "7" },
        { name: "Autre", value: "8" }
        
      ];
     
      this.fundsList = [
        { name: "Crowdfunding", value: "1" },
        { name: "Auto-Financement", value: "2" },
        { name: "Friends & Family(Love Money)", value: "3" },
        { name: "Organisme d'investissement réglementé", value: "4" },
        { name: "Business Angels", value: "5" },
        { name: "Société ou groupe de societés", value: "6" },
        { name: "Startup étrangére", value: "7" },
        { name: "Organisme d’investissement réglementé dépendant d’une société ou un groupe de sociétés", value: "8" },
        { name: "Autre", value: "9" }
      ];

      this.empty_row = {
        name: null,
        year: null,
        pay: null,
        type: null,
        funds: null
      };
      this.years = this.generateYears(9);
    }else if (this.type == "9") {
      this.headers = [
        { label: "Localisation (Pays)", type: "countries" },
        { label: "Année de création", type: "date" },
        { label: "Nombre d'employés (Hors les Cofounders)", type: "number" },
        { label: "CA consolidé (DT)", type: "number" },
        { label: "Levées de fonds (DT)", type: "number" }
      ];

      this.empty_row = {
        country: null,
        year: null,
        employees: null,
        turnover: null,
        fundraising: null
      };
      this.years = this.generateYears(9);
    }else if (this.type == "10") {
      this.headers = [
        { label: "Année", type: "date" },
        { label: "Nombre de salariés", type: "number" },
        { label: "Nombre de Stagiaires", type: "number" },
        { label: "Nombre de freelancers", type: "number" }
      ];

      this.empty_row = {
        year: null,
        employees_number: null,
        interns_number: null,
        freelancers_number: null
      };
      this.years = this.generateYears(3);
    }else if (this.type == "11") {
      this.headers = [
        { label: "Prix", type: "string" },
        { label: "Année", type: "date" },
        { label: "Localisation", type: "countries" },
        { label: "Montant", type: "number" }
      ];

      this.empty_row = {
        prix: null,
        year: null,
        country: null,
        amount: null
      };
      this.years = this.generateYears(9);
    }else if (this.type == "12") {
      this.headers = [
        { label: "Cible", type: "string" },
        { label: "Pays", type: "countries" },
        { label: "Année", type: "date" },
        { label: "Type de Marché", type: "marketType" }
      ];
      this.empty_row = {
        target: null,
        country: null,
        year: null,
        marketType: null
      };
      this.years = (this.generateAfterYears(3)).concat(this.generateYears(9));
    } else if (this.type == "13") {
      this.headers = [
        { label: "Nom de l'actionnaire", type: "string" },
        { label: "Type de l'actionnaire", type: "list" },
        { label: "N° CIN ou id société", type: "string" }
      ];
      this.empty_row = {
        name: null,
        type: null,
        cin: null
      };
      this.list = [
        { name: "Personne physique", value: "1" },
        { name: "Personne morale",value: "2" }
      ];
    } else if (this.type == "16") {
      this.headers = [
        { label: "Nom de la Startup/projet", type: "string" },
        { label: "Fondateurs", type: "tableList" },
        { label: "L'identifiant unique Rne", type: "string" },
        { label: "Nom du programme d'accompagnement", type: "string" },
        { label: "Cohorte", type: "string" },
        { label: "Date de début de la cohorte", type: "startDate" },
        { label: "Date de fin de la cohorte", type: "endDate" }
      ];
      this.empty_row = {
        startupName: null,
        foundersData: null,        
        identifiant: null,
        accompagnement: null,
        cohorte: null,
        startDate: null,
        endDate: null
      };
      this.years = this.generateYears(9);
      this.list = [
        { name: "Open innovation", value: "1" },
        { name: "Programmes d'accélération pour booster la croissance des Startups qui ont déjà un MVP",value: "2" },
        { name: "Programmes d'incubation pour booster la création des Startups et/ou de leur prototypes",value: "3" },
        { name: "Startup studio, startup factory, company builder ou venture builder qui accompagne les entrepreneurs de l'idée à la levée de fonds",value: "4" },
        { name: "Autre",value: "5" }
      ];
    } else if (this.type == "15") {
      this.headers = [
        { label: "Plan", type: "plan" },
        { label: "Mois/Année", type: "yearmonth" }
      ];
      this.empty_row = {
        plan: null,
        yearmonth: null
      };
      this.yearMonth = this.generateMonths(24);
      this.plans = [
        { name: "Finalisation du developpement de PoC", value: "1" },
        { name: "Demande du label",value: "2" },
        { name: "Levée de fonds",value: "3" },
        { name: "Go to market",value: "4" }
      ];
    } else if (this.type == "16") {
      this.headers = [
        { label: "Nom complet", type: "string" },
      ];
      this.empty_row = {
        full_name: null,
      };
    }

    this.rows = Object.keys(this.empty_row);
    if ((this.selected != null && !Array.isArray(this.selected)) || (Array.isArray(this.selected) && this.selected.length > 0)) {
      this.blocks = JSON.parse(this.selected);
    } else this.addRow();
  },
  methods: {
    addRow() {
      let empty = Object.assign({}, this.empty_row);
      this.blocks.push(empty);
    },
    deleteRow(index) {
      if((this.blocks).length>1){
        this.blocks.splice(index, 1);
      }
    },
    generateYears(nb) {
      const years = [];
      for (let index = 0; index < nb; index++) {
        let data = new Date();
        years.push({
          name: data.getFullYear() - index,
          value: data.getFullYear() - index
        });
      }
      return years;
    },
    generateMonths(nb) {
      const months = [];
      let initDate = new Date(2021, 3);
      let self = this;
      for (let index = 0; index < nb; index++) {
        let date = new Date();
        date.setMonth(initDate.getMonth() + index);
        months.push({
          name: self.months[date.getMonth()] + ' ' + date.getFullYear(),
          value: self.months[date.getMonth()] + ' ' + date.getFullYear()
        });
      }
      return months;
    },
    generateYearDeclaration(nb) {
      const years = [];
      for (let index = 0; index < nb; index++) {
        let data = new Date();
        years.push({
          name: (data.getFullYear() - 1) - index,
          value: (data.getFullYear() - 1) - index
        });
      }
      return years;
    },
    generateAfterYears(nb) {
      const years = [];
      for (let index = 1; index <= nb; index++) {
        let data = new Date();
        years.push({
          name: data.getFullYear() + index,
          value: data.getFullYear() + index
        });
      }
      return years.reverse();
    },
  },
  watch: {
    blocks: {
      handler(val) {
        this.$emit("input", val);
      },
      deep: true
    }
  }
};
</script>
